<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="eventLocationForm" v-model="formValid" validate-on="input">
        <v-container>
          <v-row class="pa-2">
            <v-col cols="12">
              <h4 class="text-h6">Veranstaltungsort</h4>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                bg-color="accent"
                variant="filled"
                label="Name des Veranstaltungsortes*"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="pa-2">
            <v-col cols="12">
              <h4 class="text-h6">Kontaktdaten</h4>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="phoneNumber"
                bg-color="accent"
                variant="filled"
                label="Telefonnummer für Rückfragen"
                required
                type="tel"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="emailAddress"
                variant="filled"
                bg-color="accent"
                label="E-Mail Adresse für Rückfragen*"
                :rules="rules.emailRules"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="pa-2">
            <v-col cols="12">
              <h4 class="text-h6">Format</h4>
              <v-radio-group v-model="format" label="" hide-details>
                <v-radio
                  v-for="(format, index) in eventFormats"
                  :key="format.id"
                  :label="`${format.name}`"
                  :value="index"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <template v-if="format === 1">
              <v-col cols="12">
                <v-text-field
                  v-model="url"
                  bg-color="accent"
                  variant="filled"
                  label="Veranstaltungslink zur Teilnahme"
                  required
                  type="text"
                ></v-text-field>
              </v-col>
            </template>
            <template v-if="format === 0 || format === 1">
              <!-- <v-col cols="12">
                <v-select
                  v-model="eventLocations"
                  bg-color="accent"
                  variant="filled"
                  label="Veranstaltungsort"
                  required
                  item-title="title"
                  item-value="id"
                  :items="api.locations"
                  type="select"
                ></v-select>
              </v-col> -->
              <v-col cols="12">
                <v-select
                  v-model="room"
                  bg-color="accent"
                  variant="filled"
                  label="Raum"
                  :items="api.rooms"
                  item-title="title"
                  item-value="id"
                  required
                  type="select"
                ></v-select>
              </v-col>
            </template>
            <template v-if="format === 2">
              <v-col cols="12">
                <v-text-field
                  v-model="url"
                  bg-color="accent"
                  variant="filled"
                  label="Veranstaltungslink zur Teilnahme"
                  required
                  type="text"
                ></v-text-field>
              </v-col>
            </template>
          </v-row>
          <v-row class="pa-2">
            <v-col cols="12">
              <h4 data-v-eca9f636="" class="text-h6">Adresse</h4>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                v-model="street"
                bg-color="accent"
                variant="filled"
                label="Straße"
                required
                type="text"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="houseNumber"
                bg-color="accent"
                variant="filled"
                label="Hausnummer"
                required
                type="text"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="additional"
                bg-color="accent"
                variant="filled"
                label="Adresszusatz"
                required
                type="text"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="zip"
                bg-color="accent"
                variant="filled"
                label="Postleitzahl"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                v-model="city"
                bg-color="accent"
                variant="filled"
                label="Stadt"
                required
                type="text"
              ></v-text-field>
            </v-col>
          </v-row>
          <LocationPicker
            objectType="detail-event"
            :latitude="latitude"
            :longitude="longitude"
            @update:latitude="latitude = $event"
            @update:longitude="longitude = $event"
          />
          <v-row class="mt-4">
            <v-col cols="12" class="text-subtitle-2">*Pflichtfelder</v-col>
          </v-row>
        </v-container>
        <Pager :invalid="!formValid" />
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Pager from "@/components/Events/Form/Pager";
import LocationPicker from "@/components/LocationPicker";
import uniqueId from "lodash/uniqueId";
import ApiBookablesService from "@/services/api/ApiBookablesService";

export default {
  components: {
    Pager,
    LocationPicker,
  },
  data() {
    return {
      formValid: false,
      roomFormat: [
        { id: uniqueId(), name: "Raum auswählen" },
        { id: uniqueId(), name: "Adresse" },
      ],
      api: {
        rooms: [],
        locations: [],
      },
      eventFormats: [
        {
          id: uniqueId(),
          name: "Präsenz",
        },
        {
          id: uniqueId(),
          name: "Hybrid",
        },
        {
          id: uniqueId(),
          name: "Online",
        },
      ],
      rules: {
        required: (value) => !!value || "Pflichtfeld",
        emailRules: [
          (v) => !!v || "E-Mail ist erforderlich",
          (v) =>
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "E-Mail muss gültig sein",
        ],
      },
    };
  },
  methods: {
    ...mapActions({
      updateValue: "events/updateForm",
    }),
    goBack() {
      this.$router.push({ name: "events" });
    },
    fetchRooms() {
      ApiBookablesService.getBookables()
        .then((response) => {
          this.api.rooms = response.data.filter(
            (resource) => resource.type === "room"
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchLocations() {
      ApiBookablesService.getBookables()
        .then((response) => {
          this.api.locations = response.data.filter(
            (location) => location.type === "event-location"
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    name: {
      get() {
        return this.$store.state.events.form.eventLocation.name;
      },
      set(value) {
        this.updateValue({
          parent: "eventLocation",
          field: "name",
          value: value,
        });
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.events.form.eventLocation.phoneNumber;
      },
      set(value) {
        this.updateValue({
          parent: "eventLocation",
          field: "phoneNumber",
          value: value,
        });
      },
    },
    emailAddress: {
      get() {
        return this.$store.state.events.form.eventLocation.emailAddress;
      },
      set(value) {
        this.updateValue({
          parent: "eventLocation",
          field: "emailAddress",
          value: value,
        });
      },
    },
    // eventLocations: {
    //   get() {
    //     return this.$store.state.events.form.eventLocation.select;
    //   },
    //   set(value) {
    //     this.updateValue({
    //       parent: "eventLocation",
    //       field: "select",
    //       value: value,
    //     });
    //   },
    // },
    room: {
      get() {
        return this.$store.state.events.form.eventLocation.room;
      },
      set(value) {
        this.updateValue({
          parent: "eventLocation",
          field: "room",
          value: value,
        });
      },
    },
    url: {
      get() {
        return this.$store.state.events.form.eventLocation.url;
      },
      set(value) {
        this.updateValue({
          parent: "eventLocation",
          field: "url",
          value: value,
        });
      },
    },
    street: {
      get() {
        return this.$store.state.events.form.eventAddress.street;
      },
      set(value) {
        this.updateValue({
          parent: "eventAddress",
          field: "street",
          value: value,
        });
      },
    },
    houseNumber: {
      get() {
        return this.$store.state.events.form.eventAddress.houseNumber;
      },
      set(value) {
        this.updateValue({
          parent: "eventAddress",
          field: "houseNumber",
          value: value,
        });
      },
    },
    additional: {
      get() {
        return this.$store.state.events.form.eventAddress.additional;
      },
      set(value) {
        this.updateValue({
          parent: "eventAddress",
          field: "additional",
          value: value,
        });
      },
    },
    city: {
      get() {
        return this.$store.state.events.form.eventAddress.city;
      },
      set(value) {
        this.updateValue({
          parent: "eventAddress",
          field: "city",
          value: value,
        });
      },
    },
    zip: {
      get() {
        return this.$store.state.events.form.eventAddress.zip;
      },
      set(value) {
        this.updateValue({
          parent: "eventAddress",
          field: "zip",
          value: value,
        });
      },
    },
    latitude: {
      get() {
        return this.$store.state.events.form.eventAddress.coordinates.latitude;
      },
      set(value) {
        this.updateValue({
          parent: "eventAddress",
          child: "coordinates",
          field: "latitude",
          value: value,
        });
      },
    },
    longitude: {
      get() {
        return this.$store.state.events.form.eventAddress.coordinates.longitude;
      },
      set(value) {
        this.updateValue({
          parent: "eventAddress",
          child: "coordinates",
          field: "longitude",
          value: value,
        });
      },
    },
    format: {
      get() {
        return this.$store.state.events.form.format;
      },
      set(value) {
        this.updateValue({ field: "format", value: value });
      },
    },
    ...mapGetters({
      form: "events/form",
    }),
  },
  created() {
    this.fetchRooms();
    this.fetchLocations();
  },
};
</script>

<style scoped></style>
